import styled, { css } from 'styled-components/macro';
import { LayoutStyled } from '@yme/atoms/accordion';
import { GridWrapper } from '@yme/atoms/grid';
import { BaseTable } from '@yme/atoms/table';
import { colorBlackTransparent50, colorCoreBlack300, colorCoreBlack900Base, defaultTransparent, } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { HeadingStylesCommon, RegularTextLevel5, RegularTextStylesCommon, } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const GridWrapperStyled = styled(GridWrapper) `
  ${ADAPTIVE.maxWidth.tablet} {
    ${LayoutStyled} {
      margin-left: ${INDENT.sm};
      margin-right: ${INDENT.sm};
    }

    -webkit-text-size-adjust: 100%;
  }

  ${ADAPTIVE.maxWidth.mobile} {
    ${LayoutStyled} {
      margin-left: ${INDENT.xs};
      margin-right: ${INDENT.xs};
    }
  }
`;
export const FlexWrapperStyled = styled(FlexWrapper) `
  &:not(:first-child) {
    margin-top: 18px;
  }
`;
export const PricingInfoTableWrapper = styled(FlexWrapper) `
  ${({ isTableScrollable }) => isTableScrollable &&
    css `
      width: 100%;
      overflow-x: auto;
      user-select: none;

      &::-webkit-scrollbar {
        display: block;
      }
    `};
`;
export const BaseTableStyled = styled(BaseTable) `
  ${({ isTableScrollable }) => isTableScrollable &&
    css `
      min-width: 360px;
      overflow-x: auto;

      thead,
      tbody {
        & > tr {
          td {
            width: auto;
            min-width: 120px;

            &:first-child {
              ${ADAPTIVE.maxWidth.tablet} {
                padding-left: 24px;
              }

              ${ADAPTIVE.maxWidth.mobile} {
                padding-left: 16px;
              }
            }

            &:last-child {
              ${ADAPTIVE.maxWidth.mobile} {
                padding-right: 16px;
              }

              ${ADAPTIVE.maxWidth.tablet} {
                padding-right: 24px;
              }
            }
          }
        }
        & > tr:has(td:nth-child(2)) > td:last-child {
          text-align: right;
        }
      }
    `};

  ${({ isProductTypeMarine }) => isProductTypeMarine &&
    css `
      tbody {
        tr {
          &:nth-child(4n-3),
          &:nth-child(4n-2) {
            background-color: ${colorBlackTransparent50};
          }

          td {
            &:last-child {
              border-bottom-right-radius: initial;
              border-top-right-radius: initial;
            }

            &:first-child {
              border-bottom-left-radius: initial;
              border-top-left-radius: initial;
            }
          }
        }
      }
    `};

  ${({ isProductTypeEBikes }) => isProductTypeEBikes &&
    css `
      & > thead,
      & > thead > tr {
        background-color: ${defaultTransparent};
      }
      & > tbody > tr:nth-child(4n + 1),
      & > tbody > tr:nth-child(4n + 2) {
        background-color: ${colorBlackTransparent50};
      }

      tbody {
        & > tr {
          td {
            &:last-child {
              border-bottom-right-radius: initial;
              border-top-right-radius: initial;
            }

            &:first-child {
              border-bottom-left-radius: initial;
              border-top-left-radius: initial;
            }
          }
        }
      }
    `};

  ${({ isProductTypeOther }) => isProductTypeOther &&
    css `
      position: relative;

      tbody {
        background-color: ${colorBlackTransparent50};

        & > tr:nth-child(2n + 1),
        & > tr {
          background-color: ${defaultTransparent};

          td {
            &:last-child {
              border-bottom-right-radius: initial;
              border-top-right-radius: initial;
            }

            &:first-child {
              border-bottom-left-radius: initial;
              border-top-left-radius: initial;
            }
          }
        }
      }
    `}
`;
export const RegularTextLevel5STyled = styled(RegularTextLevel5) `
  color: ${colorCoreBlack300};
`;
export const HeadingLevel3Styled = styled.span `
  ${HeadingStylesCommon}

  ${getTextStyles('Play', 700, 18, 24)}
  
  color: ${colorCoreBlack900Base};
  overflow-wrap: break-word;
  word-break: initial;
  text-align: right;
`;
export const HeadingLevel3OldPriceStyled = styled.span `
  ${HeadingStylesCommon}

  ${getTextStyles('Play', 700, 18, 24)}
  
  color: ${colorCoreBlack900Base};
  overflow-wrap: break-word;
  word-break: initial;
  text-decoration: line-through;
  text-align: right;

  display: flex;
  justify-content: flex-end;
`;
export const HeaderCellStyled = styled.span `
  ${RegularTextStylesCommon}

  ${getTextStyles('Ubuntu', 500, 16, 24)}
`;
export const PriceStyled = styled.span `
  ${HeadingStylesCommon}

  ${getTextStyles('Play', 700, 18, 24)}

  color: ${colorCoreBlack900Base};

  overflow-wrap: break-word;
  word-break: initial;
`;
export const DefaultCellStyled = styled.span `
  ${RegularTextStylesCommon}

  color: ${colorCoreBlack300};
`;
